<template>
	<vxe-modal v-model="modelShow" show-zoom width="1200" height="800" :title="'扩展枚举：'+extra.title" >
<!-- 		<template #corner>
			<vxe-icon name="bell-fill"></vxe-icon>
			<vxe-icon name="minus"></vxe-icon>
		</template> -->
		<template #default>
			<component :key="key" :is="component" :name="extra.name" />
		</template>
	</vxe-modal>

</template>
<style scoped>


</style>
<script>
	export default {
		props: {
			extra: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				modelShow: false,
				key: Math.random(),
				component: null
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				import(`@/views/main/emunextend/${this.extra.name}/index.vue`).then((res) => {
					this.modelShow = true
					this.component = res.default
				})
			},
			formBack() {

			},
			formshow() {

			},

		}
	}
</script>
